import { Dialog } from "construct-ui";
import moment from "moment";
import { v4 as uuid } from "uuid";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { formats } from "../../../config/constants";
import loginModel from "../../../models/login.model";
import ImeiSnInputModel from "../../../models/registration/imei-sn-input.model";
import siteModel from "../../../models/site/site.model";
import ViewBase from "../../view-base.view";
import SMEDealerPrivacyPolicyView from "../privacy-policy/sme-incentive-dealer.view";
import SMEPrivacyPolicyRAView from "../privacy-policy/sme-incentive-ra.view";



export default function ImeiSnInputView() {
  ViewBase.call(this);

  const rolesType = {
    DEALER: "DEALER",
    RA: "RA",
    NONE: "NONE"
  }
  const malaysiaCode = "MY";


  let selectedSite = null;
  let sites = [];

  let backDate = "";

  let registrations = {
    ...createRegistrationItem(),
  };

  let submitResult = null;

  let showPrivacy = false;

  let consentInfo = null;

  const isMalaysia = loginModel.credentials.country.toUpperCase() === malaysiaCode;
  let isAcceptedCheckbox = false;
 
  const handleSelectSite = (site) => {
    selectedSite = site;
  };

  const handleClickAddRow = () => {
    registrations = {
      ...registrations,
      ...createRegistrationItem(),
    };
  };

  const updateRegistrationItem = (
    key,
    value,
    registrationId,
    registrations
  ) => {
    registrations[registrationId][key] = value;
  };

  const handleChangeInputIMEI = (e, registrationId) => {
    updateRegistrationItem(
      "imei",
      e.target.value,
      registrationId,
      registrations
    );
  };

  const handleSelectDate = (e, registrationId) => {
    const newDate = moment(e.detail.date).format(formats.dateFormat);
    updateRegistrationItem("date", newDate, registrationId, registrations);
  };

  const handleChangeUserName = (e, registrationId) => {
    updateRegistrationItem(
      "userName",
      e.target.value,
      registrationId,
      registrations
    );
  };

  const handleChangeUserPhone = (e, registrationId) => {
    updateRegistrationItem(
      "userPhone",
      e.target.value,
      registrationId,
      registrations
    );
  };

  const submitRegistration = () => {

    this.showLoading();

    const data = {
      channelCd: selectedSite?.siteCode,
      dataInputs: Object.values(registrations).map(({ id, ...rest }) => ({
        ...rest,
      })),
      legalYN: isMalaysia ? "Y" : "N",
      createInput: "0060",
    };

    ImeiSnInputModel.registerDataInput(data)
      .then((res) => {
        submitResult = res;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
        showPrivacy = false;
      });
  };

  const handleClickSubmitButton = () => {
    const hasAnyEmptyImeiField = Object.values(registrations).some(
      (item) => !item.imei
    );

    if (!selectedSite?.siteCode || hasAnyEmptyImeiField) {
      this.showErrorMessage(
        this.getText("LT00000903", "Please check required fields"),
        this.getText('EM00000108',"Validation error")
      );
      return;
    }

    if (isMalaysia) {
      this.showLoading();

      fetchConsentInfo()
        .then((consentRes) => {
          consentInfo = consentRes;
          const isUserTypeNONE = consentRes?.userType?.toLowerCase() === rolesType.NONE.toLowerCase();
          if (isUserTypeNONE) {
            submitRegistration();
          } else {
            showPrivacy = true;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.hideLoading();
        });

    } else {
      submitRegistration();
    }

  };

  const handleClickConfirmSubmit = () => {
    if (!isAcceptedCheckbox) {
      return;
    }
    submitRegistration();
  }

  const handleDownload = (fileId, fileName) => {

    this.showLoading();
    ImeiSnInputModel.downloadResult(fileId, fileName)
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleChangeAccept = (e) => {
    isAcceptedCheckbox = e.target.checked
  }

  const fetchManageSites = () => {
    return siteModel.getManagedSite();
  };

  const fetchBackDateTimeLimit = () => {
    return ImeiSnInputModel.getBackDateLimitDate();
  };

  const fetchConsentInfo = () => {
    return ImeiSnInputModel.getConsentInfo();
  }

  function createRegistrationItem() {
    const id = uuid();
    const currentDate = moment().format(formats.dateFormat);
    return {
      [id]: {
        id,
        imei: "",
        date: currentDate,
        userName: "",
        userPhone: "",
      },
    };
  }

  const isDealerOrRA = () => consentInfo?.userType?.toLowerCase() !== rolesType.NONE.toLowerCase();
  const isValidToRenderPrivacyPopup = () => isMalaysia && isDealerOrRA();
  const isDealer = () => consentInfo?.userType?.toLowerCase() === rolesType.DEALER.toLowerCase();
  const isRA = () => consentInfo?.userType?.toLowerCase() === rolesType.RA.toLowerCase();

  return {
    oninit: () => {
      this.showLoading();
      Promise.all([fetchManageSites(), fetchBackDateTimeLimit()])
        .then(([sitesRes, backDateRes]) => {
          sites = sitesRes;
          backDate = backDateRes?.date;
        })
        .catch((err) => {
          this.handleError(err);
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    view: () => {
      return [
        m(".card.mb-3",
          m(".card-body",
            m(".row.g-2",
              m(".col-md-6.col-lg-3",
                m("label.form-label.mandatory",
                  this.getText("LT00000071", "Site")
                ),
                m('.border-danger',
                  m(SingleSelectComponent, {
                    items: sites,
                    selectedItem: selectedSite,
                    itemKey: "siteCode",
                    itemValue: "siteName",
                    onSelect: handleSelectSite,
                  })
                )
              ),
            )
          )
        ),

        !submitResult && m(".card.mb-3.p-3",

          m(".row.g-2 p-2",
            m(".col-md-8",
              isMalaysia && m(".text-danger.mb-2", m('span.me-1', '*'), m('span', this.getText("LT00000905", "For HPP products, end consume phone number is required to pay for incentive. Samsung terms and conditions apply."))),
              m('.fw-bold',
                m("span", this.getText("LT00000906", "Can not register Sales Date before")),
                backDate && m("span.ms-2.text-danger", moment(backDate).format(formats.dateFormat)),
              ),
            ),
            m(".col-md-4.text-end",
              m("button.btn.btn-primary", { onclick: handleClickAddRow },
                m("i.bi.bi-plus.me-0"),
                m('span', this.getText("LT00000907", "Row")))
            ),
          ),

          m(".mt-2",
            m(".row.mx-0",
              m(".col-12.p-0",
                // m(".table-responsive",
                  m("table.table",
                    m("thead.thead-bggrey",
                      m("tr.align-middle",
                        m("th[scope=col]", this.getText("LT00000908", "IMEI")),
                        m("th[scope=col]", this.getText("LT00000132", "Date")),
                        m("th[scope=col]", this.getText("LT00000909", "End User Name")),
                        m("th[scope=col]", this.getText("LT00000910", "End User Phone")),
                      )
                    ),
                    m("tbody",
                      Object.values(registrations).map((item) => {
                        return m("tr",
                          m("td",
                            m(`input.form-control.form-control-bg[type="text"]${!item.imei && ".border-danger"}`, {
                              id: item.id,
                              name: item.id,
                              value: item.imei,
                              onchange: (e) => { handleChangeInputIMEI(e, item.id) }
                            }),
                          ),
                          m("td", backDate && m(DatePickerComponent, {
                            class: 'form-control',
                            date: item.date,
                            minDate: backDate,
                            format:formats.dateFormat,
                            onselect: (e) => { handleSelectDate(e, item.id) }
                          })),
                          m("td", m('input.form-control.form-control-bg[type="text"]', {
                            id: item.id,
                            name: item.id,
                            value: item.userName,
                            onchange: (e) => { handleChangeUserName(e, item.id) }
                          })),
                          m("td", m('input.form-control.form-control-bg[type="text"]', {
                            id: item.id,
                            name: item.id,
                            value: item.userPhone,
                            onchange: (e) => { handleChangeUserPhone(e, item.id) }
                          })),
                        );
                      })
                    )
                  )
                // ),
              )
            )
          ),

          m(".text-end.p-2",
            m("button.btn.btn-primary", {
              onclick: handleClickSubmitButton
            }, this.getText("LT00000005", "Submit"))
          )

        ),

        submitResult &&
        m(".card.mb-3",
          m('.p-2',
            m(".fw-bold",
              m("span", `${this.getText("LT00000794", "Total Record(s) Inserted")}: `),
              m("span", submitResult.totalInsertedRecord),
              m("span.ms-3[role=button]", { onclick: () => handleDownload(submitResult.successFileGUID, `success_${submitResult.successFileGUID}`) }, this.getText("LT00000911", "Download inserted record(s)"))
            ),
            m(".fw-bold.mt-2",
              m("span", `${this.getText("LT00000795", "Total Record(s) Rejected")}: `),
              m("span", submitResult.totalFailRecord),
              m("span.ms-3[role=button]", { onclick: () => handleDownload(submitResult.rejectedFileGUID, `rejected_${submitResult.rejectedFileGUID}`) }, this.getText("LT00000912", "Download rejected record(s)"))
            ),
          ),

          submitResult.totalFailRecord > 0 &&
          m(".table-responsive",
            m("table.table.align-middle", [
              m("thead",
                m("tr",
                  m("th[scope=col]", this.getText("LT00000908", "IMEI")),
                  m("th[scope=col]", this.getText("LT00000717", "Model")),
                  m("th[scope=col]", this.getText("LT00000132", "Date")),
                  m("th[scope=col]", this.getText("LT00000909", "End User Name")),
                  m("th[scope=col]", this.getText("LT00000910", "End User Phone")),
                  m("th[scope=col]", this.getText("LT00000117", "Type")),
                  m("th[scope=col]", this.getText("LT00000015", "Status")),
                )
              ),
              m("tbody",
                submitResult.failRecords.map((item) =>
                  m("tr",
                    m("td", item.imei),
                    m("td", item.modelCd),
                    m("td", item.saleDate),
                    m("td", item.userName),
                    m("td", item.userPhone),
                    m("td", item.type),
                    m("td", item.status),
                  )
                ),
              ),
            ])
          )
        ),

        isValidToRenderPrivacyPopup() &&
        m(Dialog, {
          isOpen: showPrivacy,
          onClose: () => { showPrivacy = false; isAcceptedCheckbox = false; },
          title: this.getText("LT00000913", "SME Legal Clause"),
          content: [
            isDealer() && m(SMEDealerPrivacyPolicyView, {
              onChangeAccept: handleChangeAccept,
            }),
            isRA() && m(SMEPrivacyPolicyRAView, {
              onChangeAccept: handleChangeAccept,
            }),
            this.getBaseViews(),
          ],
          "class": "cui-dialog-xl",
          footer: m(".text-end", m('button.btn.btn-primary', { onclick: handleClickConfirmSubmit, disabled: !isAcceptedCheckbox }, this.getText("LT00000005", "Submit")))
        }),

        this.getBaseViews(),
      ]
    }
  }
}